import type { BrandConfig } from './types';
import { shohinJohinBrand } from './shohin-johin';
import { hypeappBrand } from './hypeapp';
import { take8Brand } from './take8';
import { usodekiBrand } from './usodeki';

export type { BrandConfig } from './types';

const brands: Record<string, BrandConfig> = {
  default: shohinJohinBrand,
  hypeapp: hypeappBrand,
  take8: take8Brand,
  usodeki: usodekiBrand,
};

/**
 * 現在のブランド設定を取得
 * VITE_BRAND 環境変数で切替（未設定時は default）
 */
export function getBrandConfig(): BrandConfig {
  const brandId = import.meta.env.VITE_BRAND || 'default';
  return brands[brandId] ?? shohinJohinBrand;
}

/** 現在のブランド設定（モジュールロード時に確定） */
export const brandConfig = getBrandConfig();

/** 認証系画面 (ログイン/新規登録/オンボーディング) のロゴ・ライト切替は、
 *  パートナー設定 (data-auth-scheme) に動的追従する useAuthScheme() /
 *  useAuthLogo() (hooks/useAuthScheme.ts) を使うこと。 */

/** テンプレート特化ホーム (usodeki バリアント) を使うブランドか。
 *  生成 UI 側の「テンプレート以外のセクションを出さない」「ホーム前提の案内文を抑制する」
 *  分岐に使う (GenerationWorkspace / GenerationPreviewPanel)。 */
export const isTemplateOnlyHome = brandConfig.homePageVariant === 'usodeki';
